import { render, staticRenderFns } from "./Inquiries.vue?vue&type=template&id=b014981a&"
import script from "./Inquiries.vue?vue&type=script&lang=js&"
export * from "./Inquiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports